<template>
    <div class="cashout-sectionThree-wrapper">
        <div class="cashout-sectionThree-main">
            <div>
                <strong> Current coyn balance:</strong>
            </div>
            <div v-if="getUserProfile.currencies">
                <strong> {{ getUserProfile.currencies.HardCurrency }}</strong>
            </div>
            <div>
                Minimum amount to exchange:
            </div>
            <div>
                {{ minCoynsAmount }}
            </div>
            <div>
                Exchange rate:
            </div>
            <div>1 coyn = {{ exchangeRate }}</div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'RequestCashbackCoynBalance',
    props: {
        minCoynsAmount: {
            type: Number,
            default: 0,
        },
        exchangeRate: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapGetters('recentEarnings', ['getUserProfile']),
    },

    mounted() {
        this.fetchRecentEarnings();
    },
    methods: {
        ...mapActions('recentEarnings', ['fetchRecentEarnings']),
    },
};
</script>
<style scoped lang="scss">
.cashout-sectionThree-wrapper {
    height: auto;
    overflow: hidden;
    background-size: cover;
    position: relative;
    border-radius: 8px;
    padding: 5%;
    border: 1px solid $blue-main;

    @media (max-width: $sm-up) {
        margin: 0 5%;
    }

    .cashout-sectionThree-main {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;

        > div {
            @include biggerText;
            font-weight: 400;
            padding-bottom: 2%;
        }
    }
}
</style>
